<template>
  <div class="sidebar_footer">
    <div class="modal-footer footer_sponsor">
      <div class="col-xs-4 col-xs-offset-2 poweredby">Powered by</div><div class="col-xs-4 nopadding"><img src="https://d3nv7i3620sxr0.cloudfront.net/img/sportraxs_logo.png" class="img-responsive"></div>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  computed: {
    ...mapGetters({
      mobile: 'mobile'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sportraxs.vue